import { createSlice } from "@reduxjs/toolkit";
import { InventoryfetchInStock } from "./thunk";

interface FetchInventoryStockState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchInventoryStockState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryStockTransferStateSlice = createSlice({
  name: "InStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(InventoryfetchInStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(InventoryfetchInStock.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(InventoryfetchInStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default InventoryStockTransferStateSlice.reducer;
